/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';
import { ReactNode, useEffect, useState } from 'react';
import { cn, SmoothMount } from '@shared/cove-ui';

export interface CollapseContentProps {
  title: string;
  className?: string;
  hideButtonClassName?: string;
  children: ReactNode;
  defaultExpand?: boolean;
  canCollapse?: boolean;
}

export default function CollapseContent({
  title,
  className,
  children,
  defaultExpand = false,
  canCollapse = true,
  hideButtonClassName,
  ...props
}: CollapseContentProps) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(!canCollapse ? true : defaultExpand);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canCollapse]);

  return (
    <div
      className={cn(
        'border-cove-navy-blue my-cove-50 lg:my-cove-75 mx-auto w-[calc(100%-50px)] max-w-screen-lg overflow-hidden rounded-none border-2 sm:rounded md:w-full',
        className
      )}
      {...props}
    >
      <div className="bg-cove-navy-blue p-8 text-white">
        <h2 className="text-h3 m-0 text-center text-white">{title}</h2>
      </div>
      <SmoothMount show={expanded} height fade>
        {children}
      </SmoothMount>

      {canCollapse && (
        <div
          className={cn(
            'md:pt-cove-35 py-cove-25 md:pb-cove-50 flex justify-center px-0',
            hideButtonClassName
          )}
        >
          <button
            className="text-cove-blue pointer mx-auto select-none border-none bg-transparent text-center font-medium underline"
            onClick={() => setExpanded(!expanded)}
          >
            {!expanded ? 'See details' : 'Hide details'}
          </button>
        </div>
      )}
    </div>
  );
}
